import type { CSSProperties } from 'react'

import type { AgentWidgetMode } from '../../domain/widgetMode'

// パネルの大きさ（px）。利用者が枠の辺や角をドラッグして変えた値
export interface AgentPanelSize {
  width: number
  height: number
}

// 大きさと位置は仮の値。UI/UX の確認で決める。
// Intercom のランチャー（右から 20px、下から 20px、48px 四方）の左に並べ、高さの中心をそろえる。
// シートの画面の右下に積まれる Salesforce の連携の警告（下から 82px より上）と重ならないよう、いちばん下の段に置く
export const WIDGET_RIGHT = 80
export const WIDGET_BOTTOM = 28

// パネルを広げても画面からはみ出さないよう、パネルの左と上に残す余白
export const VIEWPORT_MARGIN = 16

// Ant Design のモーダル（1000）より下に置き、モーダルを開いたらその下に隠れるようにする
const AGENT_WIDGET_Z_INDEX = 999

// 入力欄のまま操作がないときに、入口に戻すまでの時間（デモの値で仮）。フォーカスがあるときは戻さない
export const COMPACT_IDLE_TIMEOUT_MS = 30_000

export const LAUNCHER_STYLE: CSSProperties = {
  position: 'fixed',
  right: WIDGET_RIGHT,
  bottom: WIDGET_BOTTOM,
  zIndex: AGENT_WIDGET_Z_INDEX,
}

// パネルの既定の大きさ。利用者が枠の辺や角をドラッグして変えると、その大きさ（AgentWidget の state）で出す
const PANEL_DEFAULT_SIZE: CSSProperties = { width: 400, height: '70vh' }

/**
 * compact と expanded の枠の大きさと位置を返す。compact は入力欄の幅、expanded は利用者が変えた大きさか既定の大きさにする。
 */
export const frameStyleOf = (
  mode: Exclude<AgentWidgetMode, 'collapsed'>,
  panelSize: AgentPanelSize | null,
): CSSProperties => {
  const position: CSSProperties = {
    position: 'fixed',
    right: WIDGET_RIGHT,
    bottom: WIDGET_BOTTOM,
    zIndex: AGENT_WIDGET_Z_INDEX,
  }
  switch (mode) {
    case 'compact': {
      return { ...position, width: 360 }
    }
    case 'expanded': {
      return {
        ...position,
        ...(panelSize ?? PANEL_DEFAULT_SIZE),
        // 覚えていた大きさより画面が小さくなっても、画面からはみ出さない
        maxWidth: `calc(100vw - ${WIDGET_RIGHT + VIEWPORT_MARGIN}px)`,
        maxHeight: `calc(100vh - ${WIDGET_BOTTOM + VIEWPORT_MARGIN}px)`,
      }
    }
  }
}
